import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import SaveStatus from '../../SaveStatus';
import {useAbortableLoad} from '../../../Hooks';
import {useSelector} from 'react-redux';
import TimeTable from '../TimeTable';
import {getCriteria} from '../../../shared/helpers/getCriteria';
import {memo} from "react";
import useStyles from "./useStyles";

const ModalDialog = (props) => {

  const {
    title,
    eventType,
    onClose,
  } = props

  const classes = useStyles();

  const selectedGeoObjArray = useSelector(s => s?.ui?.selectedGeoObjArray) || []
  const dateRangeCriteria = useSelector(s => s?.ui?.dateRangeCriteria)
  const rangeStartDate = useSelector(s => s?.ui?.rangeStartDate)
  const rangeEndDate = useSelector(s => s?.ui?.rangeEndDate)

  const criteria = getCriteria(
    dateRangeCriteria,
    rangeStartDate,
    rangeEndDate,
  )

  const activitiByZone = useAbortableLoad(
    'getActivitiByZone',
    'activitiByZone',
    {objId:selectedGeoObjArray?.[0], criteria, eventType},
    (!!eventType && !!selectedGeoObjArray?.[0]),
    [eventType, selectedGeoObjArray?.[0]],
    'setActivitiByZone'
  )

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: "80%" } }}
      maxWidth="md"
      open={true}
      className={classes.dialog}
    >
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent >
        <SaveStatus dataObj={activitiByZone} successShowTime={500} errShowTime={6000} />
        {activitiByZone?.data && Array.isArray(activitiByZone.data) ? (
          activitiByZone.data.map(({widgetType, widgetLabel, dataArr: dataArrInc=[]}) => {
            const dataArr = dataArrInc.map((item)=>({...item, rawValue:parseInt(item.rawValue)}))
            if (widgetType === "timeTable") {
              return <TimeTable  widgetLabel={widgetLabel} dataArr={dataArr} />
            }
          })
        ) : null}
      </DialogContent>
      <DialogActions>

        <Button onClick={onClose} variant="outlined" color="primary">
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  )

}
export default memo(ModalDialog)